/**
 * MSAL (Microsoft Authentication Library) configuration for Entra ID SSO.
 *
 * Activation is gated by REACT_APP_AZURE_SPA_CLIENT_ID. When unset, the app
 * falls back to its dev-mode sign-in so the preview is never broken while the
 * App Registration is being provisioned.
 */
import { LogLevel } from "@azure/msal-browser";

export const TENANT_ID =
  process.env.REACT_APP_AZURE_TENANT_ID || "429efd88-0647-42e1-ae43-5f47b127b8d8";
export const SPA_CLIENT_ID = process.env.REACT_APP_AZURE_SPA_CLIENT_ID || "";
export const API_SCOPE = process.env.REACT_APP_AZURE_API_SCOPE || "";

const REDIRECT_URI =
  process.env.REACT_APP_AZURE_REDIRECT_URI || window.location.origin;
const POST_LOGOUT_URI =
  process.env.REACT_APP_AZURE_POST_LOGOUT_URI || REDIRECT_URI;

export const isMsalConfigured = () => Boolean(SPA_CLIENT_ID);

export const msalConfig = {
  auth: {
    clientId: SPA_CLIENT_ID || "00000000-0000-0000-0000-000000000000", // placeholder so PCA can still construct
    authority: `https://login.microsoftonline.com/${TENANT_ID}`,
    knownAuthorities: [`login.microsoftonline.com`],
    redirectUri: REDIRECT_URI,
    postLogoutRedirectUri: POST_LOGOUT_URI,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "sessionStorage", // tokens cleared on tab close — safer on shared machines
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        // eslint-disable-next-line no-console
        if (level === LogLevel.Error) console.error("[MSAL]", message);
      },
    },
  },
};

/**
 * Scopes for sign-in (ID token + Graph) and the custom backend API scope.
 * The custom scope returns an access token whose `aud` matches our FastAPI
 * audience config, which lets the backend validate it via JWKS.
 */
export const loginScopes = ["openid", "profile", "email", "User.Read"].concat(
  API_SCOPE ? [API_SCOPE] : [],
);

export const apiTokenRequest = {
  scopes: API_SCOPE ? [API_SCOPE] : ["openid", "profile", "email"],
};

/** Standard sign-in: silently reuses an existing Microsoft session (Outlook /
 *  Teams). Only prompts for credentials when there is no active MS session. */
export const loginRequest = {
  scopes: loginScopes,
};
